import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import b from "./styles/index.cssr.js";
import S from "../../_mixins/use-config.js";
import p from "../../_mixins/use-theme.js";
import { pxfy as C } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { createKey as z } from "../../_utils/cssr/index.js";
import { useThemeClass as $ } from "../../_mixins/use-css-vars-class.js";
import w from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-compitable.js";
import k from "../../_internal/loading/src/Loading.js";
import { warnOnce as x } from "../../_utils/naive/warn.js";
import N from "../styles/light.js";
import { defineComponent as O, watchEffect as f, computed as u, h as o } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as R } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as T } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const V = {
  small: 20,
  medium: 18,
  large: 16
}, B = Object.assign(Object.assign({}, p.props), {
  contentClass: String,
  contentStyle: [Object, String],
  description: String,
  stroke: String,
  size: {
    type: [String, Number],
    default: "medium"
  },
  show: {
    type: Boolean,
    default: !0
  },
  strokeWidth: Number,
  rotate: {
    type: Boolean,
    default: !0
  },
  spinning: {
    type: Boolean,
    validator: () => !0,
    default: void 0
  },
  delay: Number
}), J = O({
  name: "Spin",
  props: B,
  slots: Object,
  setup(e) {
    process.env.NODE_ENV !== "production" && f(() => {
      e.spinning !== void 0 && x("spin", "`spinning` is deprecated, please use `show` instead.");
    });
    const {
      mergedClsPrefixRef: a,
      inlineThemeDisabled: t
    } = S(e), i = p("Spin", "-spin", b, N, e, a), c = u(() => {
      const {
        size: s
      } = e, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: m
      } = i.value, {
        opacitySpinning: h,
        color: v,
        textColor: g
      } = m, y = typeof s == "number" ? C(s) : m[z("size", s)];
      return {
        "--n-bezier": r,
        "--n-opacity-spinning": h,
        "--n-size": y,
        "--n-color": v,
        "--n-text-color": g
      };
    }), n = t ? $("spin", u(() => {
      const {
        size: s
      } = e;
      return typeof s == "number" ? String(s) : s[0];
    }), c, e) : void 0, d = w(e, ["spinning", "show"]), l = R(!1);
    return f((s) => {
      let r;
      if (d.value) {
        const {
          delay: m
        } = e;
        if (m) {
          r = window.setTimeout(() => {
            l.value = !0;
          }, m), s(() => {
            clearTimeout(r);
          });
          return;
        }
      }
      l.value = d.value;
    }), {
      mergedClsPrefix: a,
      active: l,
      mergedStrokeWidth: u(() => {
        const {
          strokeWidth: s
        } = e;
        if (s !== void 0)
          return s;
        const {
          size: r
        } = e;
        return V[typeof r == "number" ? "medium" : r];
      }),
      cssVars: t ? void 0 : c,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    var e, a;
    const {
      $slots: t,
      mergedClsPrefix: i,
      description: c
    } = this, n = t.icon && this.rotate, d = (c || t.description) && o("div", {
      class: `${i}-spin-description`
    }, c || ((e = t.description) === null || e === void 0 ? void 0 : e.call(t))), l = t.icon ? o("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, o("div", {
      class: [`${i}-spin`, n && `${i}-spin--rotate`],
      style: t.default ? "" : this.cssVars
    }, t.icon()), d) : o("div", {
      class: [`${i}-spin-body`, this.themeClass]
    }, o(k, {
      clsPrefix: i,
      style: t.default ? "" : this.cssVars,
      stroke: this.stroke,
      "stroke-width": this.mergedStrokeWidth,
      class: `${i}-spin`
    }), d);
    return (a = this.onRender) === null || a === void 0 || a.call(this), t.default ? o("div", {
      class: [`${i}-spin-container`, this.themeClass],
      style: this.cssVars
    }, o("div", {
      class: [`${i}-spin-content`, this.active && `${i}-spin-content--spinning`, this.contentClass],
      style: this.contentStyle
    }, t), o(T, {
      name: "fade-in-transition"
    }, {
      default: () => this.active ? l : null
    })) : l;
  }
});
export {
  J as default,
  B as spinProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/spin/src/Spin.js
// module id = 26
// module chunks = 67